import DigitalCertificate from "./"

export const paths = [
    {
        path: '/digital-certificate',
        component: DigitalCertificate
    },
]

export const DigitalCertificateRouters = {
    icon: "id-card",
    testId: '',
    label: "Certificado Digital",
    path: '/digital-certificate',
    tree: []
}


// WEBPACK FOOTER //
// ./src/views/AppViews/DigitalCertificate/routers.js